<template>
    <div>
        <v-img :src="template.banner" :height="bannerHeight">
            <v-layout justify-center align-center fill-height class="light">
                <h1 class="font-weight-medium">{{template.title}}</h1>
            </v-layout>
        </v-img>
    </div>
</template>

<script>
    export default {
        props:{
            type: {
                type: String,
                default: "group"
            }
        },
        data() {
            return {
                tabActive: 0,
                templates: [
                    {
                        title: "保险商城",
                        banner: "/images/banner/group-banner-new.png",
                        value: "resources"
                    },
                    {
                        title: "员工个人保障",
                        banner: "/images/banner/person-banner-new.png",
                        value: "person"
                    },
                    // {
                    //     title: "人力资源行业保障",
                    //     banner: "/images/banner/resources-banner-new.png",
                    //     value: "resources"
                    // }
                ]
            };
        },
        computed:{
            template() {
                return this.templates.find(item => item.value === this.type);
            },
            bannerHeight() {
                return this.$vuetify.breakpoint.name === "xs" ? 150 : 377;
            }
        }
    }
</script>

<style scoped>

</style>
